<template>
  <header class="header">
    <router-link class="brand" to="/">
      <img src="http://img.lianhuazixing.com/img/static/new-logo.png" alt="莲花紫星" />
    </router-link>
    <nav class="header-nav">
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="['nav-item', { active: String(navIndex) === String(index), open: activeDropdown === index }]"
          @mouseenter="openDropdown(index, item)"
          @mouseleave="closeDropdown(index)"
        >
          <router-link
            v-if="item.path && item.path !== '' && item.children.length === 0 && !item.isLink"
            :to="item.path"
            class="nav-link"
            @click.native="navClick(index)"
          >
            {{ item.name }}
          </router-link>
          <a
            v-else-if="item.isLink"
            :href="item.path"
            target="_blank"
            class="nav-link"
            @click="navClick(index)"
          >
            {{ item.name }}
          </a>
          <a
            v-else
            href="javascript:;"
            class="nav-link"
            @click.prevent="navClick(index)"
          >
            {{ item.name }}
          </a>

          <div v-if="item.children.length > 0" class="dropdown-panel">
            <div class="dropdown-shell">
              <div
                v-for="(child, childIndex) in item.children"
                :key="childIndex"
                class="dropdown-column"
                @mouseenter="setExpanded(child)"
              >
                <a
                  v-if="child.isLink"
                  :href="child.path"
                  target="_blank"
                  class="dropdown-link"
                >
                  {{ child.name }}
                </a>
                <router-link
                  v-else-if="child.path"
                  :to="child.path"
                  class="dropdown-link"
                  @click.native="handleLeafClick(index)"
                >
                  {{ child.name }}
                </router-link>
                <a
                  v-else
                  href="javascript:;"
                  class="dropdown-link dropdown-link-parent"
                  @click.prevent="toggleExpand(child)"
                >
                  {{ child.name }}
                </a>

                <div v-if="child.children && child.children.length > 0" class="sub-dropdown" v-show="isExpanded(child)">
                  <p v-for="(grand, grandIndex) in child.children" :key="grandIndex">
                    <a v-if="grand.isLink" :href="grand.path" target="_blank" class="sub-link">
                      {{ grand.name }}
                    </a>
                    <router-link v-else :to="grand.path" class="sub-link" @click.native="handleLeafClick(index)">
                      {{ grand.name }}
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex") || "0",
      activeDropdown: null,
      expandedItem: null,
      navList: [
        { name: "首页", path: "/", children: [] },
        {
          name: "产品",
          path: "",
          children: [
            { name: "莲花紫星云", path: "http://www.shfengyu.cn", isLink: true, children: [] },
            { name: "莲花云存储", path: "/stroage", children: [] },
            { name: "token工厂", path: "/token-factory", children: [] },
            { name: "视频生成", path: "/video-generation", children: [] },
            { name: "莲小盒", path: "/lotus-box", children: [] },
            { name: "Lotus Ring", path: "/lotus-ring", children: [] },
            { name: "具身智能", path: "/jszn", children: [] },
            { name: "智能体平台", path: "https://lianhuazixing.com:9103/signin", isLink: true, children: [] }
          ]
        },
        {
          name: "解决方案",
          path: "",
          children: [
            {
              name: "技术解决方案",
              path: "",
              children: [
                { name: "AI推理", path: "/aireason" },
                { name: "对话式AI", path: "/aitalk" },
                { name: "深度学习训练", path: "/deeplearn" }
              ]
            },
            {
              name: "行业解决方案",
              path: "",
              children: [
                { name: "金融服务", path: "/finance" },
                { name: "能源电力", path: "/energy" },
                { name: "低空经济", path: "/dkjj" },
                { name: "智算代运营", path: "/zsfa" },
                { name: "高等教育", path: "/teach" },
                { name: "医疗健康和生命科学", path: "/medical" }
              ]
            }
          ]
        },
        { name: "公司动态", path: "/newsinformation", children: [] },
        {
          name: "关于我们",
          path: "",
          children: [
            { name: "业务介绍", path: "/software", children: [] },
            { name: "公司介绍", path: "/contactus", children: [] },
            { name: "合作伙伴", path: "/companyintroduction", children: [] },
            { name: "加入我们", path: "/joinus", children: [] }
          ]
        }
      ]
    };
  },
  watch: {
    $route(to) {
      this.updateNavIndex(to.path);
    }
  },
  created() {
    this.updateNavIndex(this.$route.path);
  },
  methods: {
    updateNavIndex(path) {
      switch (path) {
        case "/newsinformation":
        case "/newsdetail":
          this.navIndex = "3";
          break;
        case "/software":
        case "/companyintroduction":
        case "/contactus":
        case "/joinus":
        case "/jobchance":
        case "/jobDetails":
          this.navIndex = "4";
          break;
        case "/aireason":
        case "/aitalk":
        case "/deeplearn":
        case "/finance":
        case "/teach":
        case "/medical":
        case "/energy":
        case "/dkjj":
        case "/zsfa":
          this.navIndex = "2";
          break;
        case "/jszn":
        case "/stroage":
        case "/token-factory":
        case "/video-generation":
        case "/lotus-box":
        case "/lotus-ring":
          this.navIndex = "1";
          break;
        default:
          this.navIndex = "0";
      }
      sessionStorage.setItem("navIndex", this.navIndex);
    },
    navClick(index) {
      this.navIndex = String(index);
      sessionStorage.setItem("navIndex", this.navIndex);
    },
    openDropdown(index, item) {
      if (item.children && item.children.length > 0) {
        this.activeDropdown = index;
      }
    },
    closeDropdown(index) {
      if (this.activeDropdown === index) {
        this.activeDropdown = null;
      }
      this.expandedItem = null;
    },
    toggleExpand(item) {
      this.expandedItem = this.expandedItem === item ? null : item;
    },
    setExpanded(item) {
      this.expandedItem = item;
    },
    isExpanded(item) {
      return this.expandedItem === item;
    },
    handleLeafClick(index) {
      this.navIndex = String(index);
      sessionStorage.setItem("navIndex", this.navIndex);
      this.activeDropdown = null;
      this.expandedItem = null;
    }
  }
};
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 78px;
  padding: 0 44px;
  background: rgba(3, 10, 28, 0.84);
  border-bottom: 1px solid rgba(96, 165, 250, 0.2);
  backdrop-filter: blur(18px);
  box-shadow: 0 18px 40px rgba(2, 6, 23, 0.32);
}

.header::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(103, 232, 249, 0.65), transparent);
}

.brand {
  display: flex;
  align-items: center;
}

.brand img {
  height: 46px;
  filter: drop-shadow(0 0 12px rgba(56, 189, 248, 0.35));
}

.header-nav {
  display: flex;
  align-items: center;
}

.header-nav-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.nav-item {
  position: relative;
  padding: 0 6px;
}

.nav-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-height: 78px;
  padding: 0 16px;
  color: #dbeafe;
  font-size: 15px;
  letter-spacing: 0.04em;
  text-decoration: none;
  transition: color 0.2s ease;
}

.nav-link::after {
  content: "";
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 18px;
  height: 2px;
  border-radius: 999px;
  transform: scaleX(0);
  transform-origin: center;
  background: linear-gradient(90deg, #38bdf8, #22d3ee);
  transition: transform 0.22s ease;
}

.nav-item:hover .nav-link,
.nav-item.active .nav-link,
.nav-item.open .nav-link {
  color: #67e8f9;
}

.nav-item:hover .nav-link::after,
.nav-item.active .nav-link::after,
.nav-item.open .nav-link::after {
  transform: scaleX(1);
}

.dropdown-panel {
  display: none;
  position: absolute;
  top: calc(100% - 6px);
  left: 0;
  z-index: 5100;
  min-width: 220px;
  padding-top: 12px;
}

.nav-item.open .dropdown-panel {
  display: block;
}

.dropdown-shell {
  display: grid;
  gap: 10px;
  padding: 14px;
  border: 1px solid rgba(56, 189, 248, 0.2);
  border-radius: 18px;
  background: linear-gradient(145deg, rgba(8, 15, 35, 0.98), rgba(15, 23, 42, 0.94));
  box-shadow: 0 22px 48px rgba(2, 6, 23, 0.52);
}

.dropdown-column {
  position: relative;
}

.dropdown-link,
.sub-link {
  display: block;
  padding: 10px 12px;
  color: #dbeafe;
  text-decoration: none;
  border-radius: 12px;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.dropdown-link:hover,
.sub-link:hover {
  color: #67e8f9;
  background: rgba(14, 165, 233, 0.12);
  transform: translateX(2px);
}

.dropdown-link-parent::after {
  content: ">";
  float: right;
  color: rgba(125, 211, 252, 0.8);
}

.sub-dropdown {
  margin-top: 8px;
  padding: 10px;
  border-radius: 14px;
  background: rgba(15, 23, 42, 0.85);
  border: 1px solid rgba(96, 165, 250, 0.18);
}

.sub-dropdown p {
  margin: 0;
}

@media (max-width: 1080px) {
  .header {
    padding: 0 18px;
    align-items: flex-start;
    flex-direction: column;
  }

  .header-nav {
    width: 100%;
    overflow-x: auto;
  }

  .header-nav-wrapper {
    gap: 2px;
  }

  .nav-link {
    min-height: 58px;
    padding: 0 10px;
    font-size: 14px;
    white-space: nowrap;
  }

  .dropdown-panel {
    left: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue